<div class="page-header" *ngIf="!isModal">
  <div class="page-title">
    <h3>
      {{
        !createMode
          ? ('PICKUP_PLACE' | translate) + ' / ' + pickupPlace.name
          : ('NEW_PICKUP_PLACE' | translate)
      }}
    </h3>
  </div>
  <div class="pull-right">
    <div class="form-actions no-wrap">
      <app-item-detail-form-actions
        [createMode]="createMode"
        [disableSaveItem]="
          form.invalid ||
          sendingForm ||
          (!loadingLocations && locations.length === 0) ||
          (!loadingZones && zones.length === 0)
        "
        [isModal]="isModal"
        [sendingForm]="sendingForm"
        [viewMode]="viewMode"
        (canceled)="onCanceled()"
        (edited)="onEditedPickupPlace()"
        (saved)="onSavedPickupPlace()"
      >
      </app-item-detail-form-actions>
    </div>
  </div>
</div>

<div
  class="alert alert-danger fade in"
  *ngIf="
    (!loadingLocations && locations.length === 0) ||
    (form.controls['location_id'].value && !loadingZones && zones.length === 0)
  "
>
  <h4>{{ 'PLEASE_CORRECT_ERRORS' | translate }}</h4>
  <button
    type="button"
    class="btn btn-inverse"
    (click)="openLocationsModal()"
    *ngIf="locations.length === 0"
  >
    <i class="fa fa-plus"></i> {{ 'NEW' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-inverse"
    (click)="openZonesModal()"
    *ngIf="zones.length === 0"
  >
    <i class="fa fa-plus"></i> {{ 'NEW' | translate }}
  </button>
</div>

<form [formGroup]="form" class="form-horizontal no_marginxx" autocomplete="off" novalidate>
  <app-translation-options
    [defaultLanguage]="defaultLanguage"
    [additionalLanguages]="additionalLanguages"
    (openedTranslation)="onOpenedTranslation($event)"
    *ngIf="!createMode && additionalLanguages.length > 0"
  ></app-translation-options>
  <div class="widget">
    <div class="widget-header">
      <h4>{{ 'PICKUP_PLACE_DETAILS' | translate }}</h4>
    </div>
    <div class="widget-content form-vertical no-margin">
      <div class="row">
        <div class="col-md-4 col-lg-3">
          <span *ngIf="pickupPlace.logoUrl">
            <a
              fancybox
              class="fancybox"
              href="{{ pickupPlace.logoUrl }}"
              title="{{ pickupPlace.name }}"
            >
              <img
                [src]="pickupPlace.logoUrl"
                alt="{{ pickupPlace.name }}"
                title="{{ 'ENLARGE_PHOTO' | translate }}"
                class="img-center"
              />
            </a>
          </span>
          <span *ngIf="!pickupPlace.logoUrl" class="default-img img-center">
            <img id="logo-image-preview" class="img-center" />
          </span>

          <div class="logo_bar" [hidden]="viewMode">
            <button
              type="button"
              class="btn btn-xs btn-danger"
              (click)="openLogo()"
              title="{{ labelAddLogo | translate }}"
              [disabled]="editMode && form.invalid"
            >
              <i class="fa" [ngClass]="editMode ? 'fa-pencil' : 'fa-plus'"></i>
            </button>
          </div>
        </div>
        <div class="col-md-8 col-lg-9">
          <!-- Name -->
          <div class="form-group">
            <label class="control-label">
              {{ 'NAME' | translate }}
              <span class="required" [hidden]="viewMode || isHotel">*</span>
            </label>
            <div *ngIf="viewMode && !isHotel" class="form-label">
              {{ pickupPlace.name }}
            </div>
            <div *ngIf="!viewMode && !isHotel">
              <input type="text" class="form-control" formControlName="name" maxlength="255" />
              <app-form-errors
                [control]="form.controls['name']"
                [formSubmited]="formSubmited"
              ></app-form-errors>
              <!-- [messages]="errorMessages['name']" -->
              <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
            </div>
          </div>

          <!-- Address -->
          <div class="form-group">
            <label class="control-label">{{ 'ADDRESS' | translate }}</label>
            <div [hidden]="!viewMode && !isHotel" class="form-label">
              <!-- <span [hidden]="!pickupPlace.address">
                {{ pickupPlace.address }}
              </span>
              <span [hidden]="pickupPlace.address">-</span> -->
              {{ pickupPlace.address || '-' }}
            </div>
            <div [hidden]="viewMode && !isHotel">
              <textarea class="form-control" formControlName="address" rows="3"></textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </div>
    <!-- /.widget-content -->
  </div>
  <!-- /.widget -->

  <br />
  <div class="widget">
    <div class="widget-header">
      <h4>{{ 'DETAILS' | translate }}</h4>

      <div class="toolbar" *ngIf="!viewMode && !isHotel">
        <div class="btn-group">
          <span class="dropdown-toggle btn btn-xs" data-toggle="dropdown">
            <i class="fa fa-cog"></i>
          </span>
          <ul class="dropdown-menu pull-right">
            <li>
              <a href (click)="openLocationsModal()">
                <i class="fa fa-map-marker fa-sized"></i> {{ 'EDIT_LOCATIONS' | translate }}
              </a>
            </li>
            <li>
              <a href (click)="openZonesModal()">
                <i class="fa fa-map fa-sized"></i> {{ 'EDIT_ZONES' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="widget-content">
      <!-- Category -->
      <div class="form-group">
        <div *ngIf="!pickupPlace.type_id">
          <label class="col-md-3 control-label">
            <span class="required" [hidden]="viewMode">*</span>
            {{ 'CATEGORY' | translate }}
          </label>
          <div class="col-md-6">
            <div *ngIf="viewMode" class="form-label">
              {{ pickupPlace.type | uppercase | translate }}
            </div>
            <div *ngIf="!viewMode">
              <mat-select formControlName="type" placeholder="{{ 'SELECT_CATEGORY' | translate }}">
                <mat-option *ngFor="let option of pickupPlaceOptions" [value]="option.type">
                  {{ option.name | translate }}
                </mat-option>
              </mat-select>
              <app-form-errors
                [control]="form.controls['type']"
                [formSubmited]="formSubmited"
              ></app-form-errors>
            </div>
          </div>
        </div>

        <div *ngIf="pickupPlace.type_id">
          <label class="col-md-3 control-label">{{ 'CATEGORY' | translate }}</label>
          <div class="col-md-9">
            <i class="fa fa-building" title="{{ pickupPlace.type }}">Hotel</i>
            <hr />
            <a href="#/hotels/{{ pickupPlace.type_id }}" class="btn btn-xs btn-inverse">
              <i class="fa fa-eye"></i> {{ 'VIEW_ITEM' | translate }}
            </a>
          </div>
        </div>
      </div>

      <hr />

      <!-- Location -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required" [hidden]="viewMode">*</span>
          {{ 'LOCATION' | translate }}
        </label>
        <div class="col-md-6">
          <div *ngIf="viewMode" class="form-label">
            {{ pickupPlace.location.name }}
          </div>
          <div *ngIf="!viewMode">
            <div *ngIf="!isHotel">
              <div *ngIf="!loadingLocations">
                <div *ngIf="locations.length > 0">
                  <ng-select
                    [items]="locations"
                    [clearable]="false"
                    groupBy="parent"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="{{ 'SELECT' | translate }}"
                    formControlName="location_id"
                    (change)="selectLocation($event.id)"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      <div class="treelevel-{{ item.treelevel }}">
                        {{ item.name }}
                        <small *ngIf="item.id && item.is_superior_location">
                          ({{ 'SUPERIOR_LOCATION' | translate }})
                        </small>
                      </div>
                    </ng-template>
                  </ng-select>

                  <!-- <mat-select
                    formControlName="location_id"
                    placeholder="{{ 'SELECT_LOCATION' | translate }}"
                    (selectionChange)="selectLocation($event.value)"
                  >
                    <mat-option *ngFor="let location of locations" [value]="location.id">
                      <div class="treelevel-{{ location.treelevel }}">
                        {{ location.name }}
                      </div>
                    </mat-option>
                  </mat-select> -->
                  <app-form-errors
                    [control]="form.controls['location_id']"
                    [formSubmited]="formSubmited"
                  ></app-form-errors>
                </div>
                <!-- Empty locations -->
                <div *ngIf="locations.length === 0">
                  <div class="label label-danger">{{ 'NO_LOCATIONS_SET' | translate }}</div>
                  <a href class="btn btn-xs btn-success" (click)="openLocationsModal()">
                    <i class="fa fa-plus"></i> {{ 'NEW' | translate }}
                  </a>
                </div>
              </div>
              <div *ngIf="loadingLocations" class="form-label text-muted">
                {{ 'LOADING' | translate }}...
              </div>
            </div>

            <div *ngIf="isHotel">
              {{ pickupPlace.location.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- Zone -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required" [hidden]="viewMode">*</span>
          {{ 'ZONE' | translate }}
        </label>
        <div class="col-md-6">
          <div *ngIf="viewMode" class="form-label">
            {{ pickupPlace.zone.name }}
          </div>
          <div *ngIf="!viewMode">
            <div *ngIf="!isHotel">
              <div *ngIf="form.controls['location_id'].value">
                <div *ngIf="!loadingZones">
                  <div *ngIf="zones.length > 0">
                    <mat-select
                      formControlName="zone_id"
                      placeholder="{{ 'SELECT_ZONE' | translate }}"
                    >
                      <mat-option *ngFor="let zone of zones" [value]="zone.id">
                        {{ zone.name }}
                      </mat-option>
                    </mat-select>
                    <app-form-errors
                      [control]="form.controls['zone_id']"
                      [formSubmited]="formSubmited"
                    ></app-form-errors>
                  </div>
                  <div *ngIf="zones.length === 0">
                    <div class="label label-danger">
                      {{ 'NO_ZONES_SET_FOR_LOCATION' | translate }}
                    </div>
                    <a href class="btn btn-xs btn-success" (click)="openZonesModal()">
                      <i class="fa fa-plus"></i> {{ 'NEW' | translate }}
                    </a>
                  </div>
                </div>
                <div *ngIf="loadingZones" class="form-label text-muted">
                  {{ 'LOADING' | translate }}...
                </div>
              </div>
              <div *ngIf="!form.controls['location_id'].value" class="form-label">-</div>
            </div>

            <div *ngIf="isHotel">
              {{ pickupPlace.zone.name }}
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-3 control-label">{{ 'GEO_COORDINATES' | translate }}</label>
        <div class="col-md-9">
          <div *ngIf="googleMapLoaded">
            <app-map
              [lat]="pickupPlace.geo_lat"
              [lng]="pickupPlace.geo_lng"
              [zoom]="pickupPlace.geo_zoom"
              [viewMode]="viewMode"
              (selectedMapPlace)="onSelectedMapPlace($event)"
            ></app-map>
          </div>
        </div>
      </div>

      <!-- Coordinates -->
      <div class="form-group">
        <div class="col-md-9 col-md-offset-3">
          <div class="row">
            <div class="col-md-4">
              {{ 'LATITUDE' | translate }}
              <div *ngIf="viewMode" class="form-label">
                {{ pickupPlace.geo_lat || '-' }}
              </div>
              <div *ngIf="!viewMode">
                <div *ngIf="!isHotel">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="geo_lat"
                    placeholder="{{ 'ENTER_LATITUDE' | translate }}"
                    maxlength="50"
                  />
                  <!-- allow-pattern="map" -->
                </div>
                <div *ngIf="isHotel">
                  {{ pickupPlace.geo_lat }}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              {{ 'LONGITUDE' | translate }}
              <div *ngIf="viewMode" class="form-label">
                {{ pickupPlace.geo_lng || '-' }}
              </div>
              <div *ngIf="!viewMode">
                <div *ngIf="!isHotel">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="geo_lng"
                    placeholder="{{ 'ENTER_LONGITUDE' | translate }}"
                    maxlength="50"
                  />
                  <!-- allow-pattern="map" -->
                </div>
                <div *ngIf="isHotel">
                  {{ pickupPlace.geo_lng }}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              {{ 'ZOOM' | translate }}
              <div *ngIf="viewMode" class="form-label">
                {{ pickupPlace.geo_zoom || '-' }}
              </div>
              <div *ngIf="!viewMode">
                <div *ngIf="!isHotel">
                  <input
                    type="number"
                    class="form-control"
                    formControlName="geo_zoom"
                    placeholder="{{ 'ENTER_ZOOM' | translate }}"
                    [appInputNumberMaxLength]="2"
                  />
                  <!-- allow-pattern="currency" -->
                  <!-- number-converter -->

                  <app-form-errors
                    [control]="form.controls['geo_zoom']"
                    [formSubmited]="formSubmited"
                  ></app-form-errors>
                  <!-- INVALID_NUMBER -->
                </div>
                <div *ngIf="isHotel">
                  {{ pickupPlace.geo_zoom }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.widget-content -->
  </div>
  <!-- /.widget -->

  <div class="form-actions no-wrap">
    <app-item-detail-form-actions
      [createMode]="createMode"
      [disableSaveItem]="
        form.invalid ||
        sendingForm ||
        (!loadingLocations && locations.length === 0) ||
        (!loadingZones && zones.length === 0)
      "
      [isModal]="isModal"
      [sendingForm]="sendingForm"
      [viewMode]="viewMode"
      (canceled)="onCanceled()"
      (edited)="onEditedPickupPlace()"
      (saved)="onSavedPickupPlace()"
    >
    </app-item-detail-form-actions>
  </div>
</form>

<!-- <div
            appMap
            id="map"
            class="map"
            [lat]="pickupPlace.geo_lat"
            [lng]="pickupPlace.geo_lng"
            [zoom]="pickupPlace.geo_zoom"
            style="height: 400px"
          ></div> -->
